// DOM id of the sitewide trial banner. Shared because layout code outside the banner
// (sticky query bars, filter boxes) measures the rendered element to offset itself.
export const TRIAL_BANNER_ID = "TrialBanner";
